import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_SERVICE_TAG } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubProfileService } from "@/features/LenderHub/Profile/services/profileService";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const deleteLendingProgramEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    deleteLendingProgram: builder.mutation({
      query: (lendingProgramId) => ({
        url: `lending-programs/${lendingProgramId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: LENDING_PROGRAM_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          sendAnalytics(ANALYTIC_EVENTS.LENDING_PROGRAM_DELETED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Lending Program have been deleted!",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubProfileService.util.invalidateTags(["LenderHubProfile"]));
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteLendingProgramMutation } = deleteLendingProgramEndpoint;

